// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3XyE4","productName":"Table_productName__vrMwY"};